export { default } from './RecommendedCourses';
